import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const PropertyContext = createContext(null);

export const useProperty = () => {
  const context = useContext(PropertyContext);
  if (!context) {
    throw new Error('useProperty must be used within a PropertyProvider');
  }
  return context;
};

export const PropertyProvider = ({ children }) => {
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDefaultProperty();
  }, []);

  const fetchDefaultProperty = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${API_URL}/properties`);
      console.log('Properties response:', response.data);
      if (response.data.length > 0) {
        // Find Acqualina Resort specifically, or fall back to first property
        const acqualina = response.data.find(p => 
          p.name && p.name.toLowerCase().includes('acqualina')
        );
        setProperty(acqualina || response.data[0]);
      } else {
        setError('No properties found');
      }
    } catch (err) {
      console.error('Failed to load property:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const refetch = () => {
    fetchDefaultProperty();
  };

  return (
    <PropertyContext.Provider value={{ 
      property, 
      propertyId: property?.id,
      propertyName: property?.name || 'Acqualina Resort',
      loading,
      error,
      refetch
    }}>
      {children}
    </PropertyContext.Provider>
  );
};
